<template>
  <VcDropdown v-model="isDropdownOpen">
    <template #activator="{ on, attrs }">
      <div v-bind="attrs"
           v-on="on"
           class="text-field"
           :class="{'text-field--open': isDropdownOpen}">
        <VcTextField :label="label"
                     :value="textFieldValue"
                     readonly
                     append-icon="$caret_down"/>
      </div>
    </template>
    <VcList class="check-list"
            :items="items">
      <template v-slot="item">
        <VcCheckbox :label="item.name"
                    :checked="item.selected"
                    @change="val => onItemChange(item, !!val)"/>
      </template>
    </VcList>
  </VcDropdown>
</template>

<script>
export default {
  name: "MultiSelectDropdown",
  props: {
    label: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    noneCheckedLabel: {
      type: String
    },
    allCheckedLabel: {
      type: String
    },
    someCheckedLabel: {
      type: String
    }
  },
  data() {
    return {
      isDropdownOpen: false,
      selectedItems: []
    }
  },
  created() {
    this.updateItems();
  },
  updated() {
    this.updateItems();
  },
  computed: {
    textFieldValue() {
      if (!this.selectedItems.length && this.noneCheckedLabel) {
        return this.noneCheckedLabel;
      }

      if (this.selectedItems.length === this.items.length && this.allCheckedLabel) {
        return this.allCheckedLabel;
      }

      if (this.someCheckedLabel) {
        return this.someCheckedLabel;
      }

      return this.selectedItems.map(item => item.name).join(', ');
    }
  },
  methods: {
    onItemChange(item, checked) {
      if (checked) {
        this.selectedItems.push(item);
        this.selectedItems.sort((a,b) => a.identifier - b.identifier);
      } else {
        const index = this.selectedItems.findIndex(selectedItem => selectedItem.identifier === item.identifier);

        if (index > -1) {
          this.selectedItems.splice(index, 1);
        }
      }

      this.$emit('change', this.selectedItems);
    },
    updateItems() {
      this.selectedItems = this.items.filter(item => item.selected);
      this.selectedItems.sort((a,b) => a.identifier - b.identifier);
    }
  }
}
</script>

<style lang="scss" scoped>
.text-field {

  ::v-deep .v-input__icon {
    transition: 0.3s;

    .v-icon__component {
      height: 9px !important;
      width: 9px !important;
      fill: var(--gray-darken-2);
      color: var(--gray-darken-2);
    }
  }

  &--open {

    ::v-deep .v-input__icon {
      transform: rotate(180deg);
    }
  }
}

.check-list {

  ::v-deep .vc-base-list-item {
    padding: 0;

    &.active {
      background-color: unset !important;
    }

    .v-input--checkbox {
      margin: 0;

      .v-input__slot {
        padding: var(--size-value2) var(--size-value4);
      }
    }
  }
}
</style>
